import Vue from 'vue'
import gets from './language.js'
import '../lf'
import {
    userRequest
} from '../request/user'

const name ={
    state: {
        name: 1
    },
}
const Frame = {
    state: {
        name: 'Frame'
    },
    mutations: {},
    actions: {
        getdata(context) {
            console.log(Frame)
        }
    },
    getters: {}
}
const Navs = {
    state: {
        name: 'Top',
        navs: [
          {
                name: gets('$商城'),
                twoNavs: [
                    {
                        name: gets('$首页'),
                        tag: 'Root',
                        url: '/Root',
                        moduleID: -10000000
                    },
                    {
                        name: gets('$商城'),
                        tag: 'MyShoppingMall',
                        url: '/MyShoppingMall',
                        moduleID: 14001
                    },

                    {
                        name: gets('$添加产品'),
                        tag: '/ShopAddProduct/:ID',
                        url: '/ShopAddProduct/0',
                        moduleID: 14002
                    },
                    {
                        name: gets('$商城产品管理'),
                        tag: 'ProductMall',
                        url: '/ProductMall',
                        moduleID: 14003
                    },
                    {
                        name: gets('$新增采购单'),
                        tag: '/AddMallPurchase/:ID',
                        url: '/AddMallPurchase/0',
                        moduleID: 14004
                    },
                    {
                        name: gets('$商城采购管理'),
                        tag: 'ASN_PurchasesMall',
                        url: '/ASN_PurchasesMall',
                        moduleID: 14005
                    },

                ]
            },
            {
                name: gets('$系统管理'),
                twoNavs: [
                    // {
                    //     name: gets('$首页'),
                    //     tag: 'Root',
                    //     url: '/Root',
                    //     moduleID: -10000000
                    // },
                    {
                        name: gets('$用户管理'),
                        tag: 'UserManage',
                        url: '/UserManage',
                        moduleID: 5
                    },
                    {
                        name: gets('$部门管理'),
                        tag: 'DepartmentPage',
                        url: '/DepartmentPage',
                        moduleID: 6
                    },
                    {
                        name: gets('$角色管理'),
                        tag: 'RolePage',
                        url: '/RolePage',
                        moduleID: 4
                    },
                    {
                        name: gets('$权限设置'),
                        tag: 'RightPage',
                        url: '/RightPage',
                        moduleID: 3
                    },
                    {
                        name: gets('$新闻类型'),
                        tag: 'Sys_NewsType',
                        url: '/Sys_NewsType',
                        moduleID: 1002
                    },

                    {
                        name: gets('$新闻列表'),
                        tag: 'Sys_New',
                        url: '/Sys_New',
                        moduleID: 1003
                    },
                    {
                        name: gets('$地区信息'),
                        tag: 'RegionPage',
                        url: '/RegionPage',
                        moduleID: 8
                    },
                    {
                        name: gets('$公司设置'),
                        tag: 'CompanyInfo',
                        url: '/CompanyInfo',
                        moduleID: 5001
                    },
                    {
                        name: gets('$邮件设置'),
                        tag: 'EmailConfig',
                        url: '/EmailConfig',
                        moduleID: 5002
                    },
                    {
                        name: gets('$邮件模板设置'),
                        tag: 'EmailMessage',
                        url: '/EmailMessage',
                        moduleID: 35
                    },

                    {
                        name: gets('$颜色标记'),
                        tag: 'ColorMark',
                        url: '/ColorMark',
                        moduleID: 5003
                    },
                    {
                        name: gets('$增值服务'),
                        tag: 'AddService',
                        url: '/AddService',
                        moduleID: 5004
                    },
                    {
                        name: gets('$语言国际化'),
                        tag: 'CharacterParent',
                        url: '/CharacterParent',
                        moduleID: 10000
                    },

                    {
                        name: gets('$密码修改'),
                        tag: 'UpdatePassword',
                        url: '/UpdatePassword',
                        moduleID: 1001
                    },
                ]
            },

            {
                name: gets('$客户管理'),
                twoNavs: [{
                        name: gets('$客户列表'),
                        tag: 'Customer',
                        url: '/Customer',
                        moduleID: 7
                    },

                    {
                        name: gets('$工单类型'),
                        tag: 'QuestionType',
                        url: '/QuestionType',
                        moduleID: 6017
                    },


                    {
                        name: gets('$工单列表'),
                        tag: 'Question',
                        url: '/Question',
                        moduleID: 6018
                    },

                    {
                        name: gets('$询价列表'),
                        tag: 'PurchaseRequest',
                        url: '/PurchaseRequest',
                        moduleID: 13001
                    },

                ]
            },

            {
                name: gets('$订单管理'),
                twoNavs: [{
                        name: gets('$订单列表'),
                        tag: 'OrderList',
                        url: '/OrderList',
                        moduleID: 27
                    },
                    {
                        name: gets('$运费查询'),
                        tag: 'FreightInquiries',
                        url: '/FreightInquiries',
                        moduleID: 6016
                    },
                    {
                        name: gets('$上传AfterShip'),
                        tag: 'UploadAfterShip',
                        url: '/UploadAfterShip',
                        moduleID: 6020
                    },

                    {
                        name: gets('$订单审核'),
                        tag: 'OrderSubmit',
                        url: '/OrderSubmit',
                        moduleID: 13301
                    },             
                    {
                        name: gets('$港前退件'),
                        tag: 'OrderReturns',
                        url: '/OrderReturns',
                        moduleID: 27
                    }, 

                ]
            },

            {
                name: gets('$渠道管理'),
                twoNavs: [{
                        name: gets('$渠道类型'),
                        tag: 'ChannelType',
                        url: '/ChannelType',
                        moduleID: 11
                    },
                    // {
                    //   name: gets('$源渠道'),
                    //   tag: 'BaseChannel',
                    // },
                    {
                        name: gets('$我的渠道'),
                        tag: 'ChannelInfoPage',
                        url: '/ChannelInfoPage',
                        moduleID: 9
                    },

                    // {
                    //   name: gets('$渠道套餐'),
                    //   tag: 'ChannelMeal',
                    //   url: '/ChannelMeal'
                    // },
                    {
                        name: gets('$下家公司信息'),
                        tag: 'NextCompany',
                        url: '/NextCompany',
                        moduleID: 12
                    },
                    // {
                    //     name: gets('$渠道附加费'),
                    //     tag: 'ChannelSurcharge',
                    //     url: '/ChannelSurcharge',
                    //     moduleID: 13
                    // },
                    {
                        name: gets('$渠道订单项配置'),
                        tag: 'ChannelItemSetup',
                        url: '/ChannelItemSetup',
                        moduleID: 24
                    },
                    {
                        name: gets('$渠道预报方法'),
                        tag: 'ChannelApiType',
                        url: '/ChannelApiType',
                        moduleID: 24
                    },
                    // {
                    //   name: gets('$发件管理'),
                    //   tag: 'SendAddress',
                    //   url: '/SendAddress'
                    // },
                ]
            },
            {
                name: gets('$采购管理'),
                twoNavs: [
                    {
                        name: gets('$采购账号管理'),
                        tag: 'PurchaseAccount',
                        url: '/PurchaseAccount',
                        moduleID: 6023
                    },
                    {
                        name: gets('$产品类型'),
                        tag: 'ProductType',
                        url: '/ProductType',
                        moduleID: 6001
                    },
                    {
                        name: gets('$产品管理'),
                        tag: 'Product',
                        url: '/Product',
                        moduleID: 6002
                    },
                    {
                      name: gets('$1688产品映射'),
                      tag: 'Productmapping',
                      url: '/Productmapping',
                      moduleID: 6024
                    },
                    {
                        name: gets('$供应商'),
                        tag: 'Supplier',
                        url: '/Supplier',
                        moduleID: 6004
                    },
                    {
                        name: gets('$采购管理'),
                        tag: 'ASN_Purchases',
                        url: '/ASN_Purchases',
                        moduleID: 6005
                    },
                ]
            },

            {
                name: gets('$仓库管理'),
                twoNavs: [{
                        name: gets('$仓库管理'),
                        tag: 'Warehouse',
                        url: '/Warehouse',
                        moduleID: 14
                    },
                    {
                        name: gets('$库位管理'),
                        tag: 'WareHousesLocation',
                        url: '/WareHousesLocation',
                        moduleID: 16
                    },
                    {
                        name: gets('$库存调拨'),
                        tag: 'WareHousesLocationReplace',
                        url: '/WareHousesLocationReplace',
                        moduleID: 16
                    },
                    {
                        name: gets('$拣货路径规划'),
                        tag: 'WareHousesPath',
                        url: '/WareHousesPath',
                        moduleID: 15
                    },

                    {
                        name: gets('$客户仓库'),
                        tag: 'CustomerWhouse',
                        url: '/CustomerWhouse',
                        moduleID: 25
                    },
                    {
                        name: gets('$创建收货框'),
                        tag: 'AddReceiveBox',
                        url: '/AddReceiveBox/0',
                        moduleID: 6009
                    },
                    {
                        name: gets('$包裹签收'),
                        tag: 'ParcelSigning',
                        url: '/ParcelSigning',
                        moduleID: 6009
                    },
                    {
                        name: gets('$扫描入库'),
                        tag: 'ASN_ReceivesScan',
                        url: '/ASN_ReceivesScan/0',
                        moduleID: 6009
                    },
                    {
                        name: gets('$采购入库'),
                        tag: 'ASN_Receives',
                        url: '/ASN_Receives',
                        moduleID: 6009
                    },
                    // {
                    //   name: gets('$产品库存1'),
                    //   tag: 'InventoryTotal',
                    //   url: '/InventoryTotal',
                    //   moduleID: 6007
                    // },

                    {
                        name: gets('$库位库存'),
                        tag: 'Inventory',
                        url: '/Inventory',
                        moduleID: 6008
                    },

                    {
                        name: gets('$产品库存'),
                        tag: 'InventoryCustomer',
                        url: '/InventoryCustomer',
                        moduleID: 6006
                    },


                    {
                        name: gets('$库存调整'),
                        tag: 'InventoryInAndOut',
                        url: '/InventoryInAndOut',
                        moduleID: 6010
                    },



                    {
                        name: gets('$盘点'),
                        tag: 'InventoryCheck',
                        url: '/InventoryCheck',
                        moduleID: 6022
                    },



                ]
            },

            {
                name: gets('$财务管理'),
                twoNavs: [{
                        name: gets('$银行信息'),
                        tag: 'BankInfo',
                        url: '/BankInfo',
                        moduleID: 30
                    },
                    {
                        name: gets('$汇率设置'),
                        tag: 'ExchangeRate',
                        url: '/ExchangeRate',
                        moduleID: 31
                    },

                    {
                        name: gets('$客户充值'),
                        tag: 'AccountInCome',
                        url: '/AccountInCome',
                        moduleID: 32
                    },
                    
                    {
                        name: gets('$账单'),
                        tag: 'Invoice',
                        url: '/Invoice',
                        moduleID: 33
                    },
                    {
                        name: gets('$仓库计费设置'),
                        tag: 'WareHouseOperateFee',
                        url: '/WareHouseOperateFee',
                        moduleID: 33
                    },
                    {
                        name: gets('$仓库计费文件'),
                        tag: 'ExportFilePage',
                        url: '/ExportFilePage',
                        moduleID: 33
                    },
                    {
                        name: gets('$收款明细'),
                        tag: 'PaidDetail',
                        url: '/PaidDetail',
                        moduleID: 34
                    },
                    {
                        name: gets('$挂号费折扣'),
                        tag: 'RegistrationDiscount',
                        url: '/RegistrationDiscount',
                        moduleID: 6019
                    },
                     {
                        name: gets('$统计客户发货情况'),
                        tag: 'CustomerDelivery',
                        url: '/CustomerDelivery',
                        moduleID: 6030
                    }, 

                ]
            },
            {
                name: gets('$物流管理'),
                twoNavs: [{
                        name: gets('$收货扣费操作'),
                        tag: 'BuckleCharge',
                        url: '/BuckleCharge',
                        moduleID: 28
                    },
                    {
                        name: gets('$撤销收货'),
                        tag: 'CancelReceipt',
                        url: '/CancelReceipt',
                        moduleID: 6015
                    },

                    {
                        name: gets('$打印订单'),
                        tag: 'PrintLabel',
                        url: '/PrintLabel',
                        moduleID: 6013
                    },
                    {
                        name: gets('$拣货管理'),
                        tag: 'PickUpBatch',
                        url: '/PickUpBatch',
                        moduleID: 6011
                    },
                    {
                        name: gets('$多物品分单'),
                        tag: 'MultiItemOrder',
                        url: '/MultiItemOrder',
                        moduleID: 6011
                    },


                    {
                        name: gets('$订单检测'),
                        tag: 'OrderForProductCheck',
                        url: '/OrderForProductCheck',
                        moduleID: 6011
                    },

                    {
                        name: gets('$单物品订单打印'),
                        tag: 'SingleOrderReinsurance',
                        url: '/SingleOrderReinsurance',
                        moduleID: 6011
                    },
                    {
                        name: gets('$发货装袋'),
                        tag: 'AddDeliverBacth',
                        url: '/AddDeliverBacth/0',
                        moduleID: 6012
                    },
                    {
                        name: gets('$装袋列表'),
                        tag: 'DeliverBacth',
                        url: '/DeliverBacth',
                        moduleID: 6012
                    },




                    {
                        name: gets('$取消订单'),
                        tag: 'CancelOrder',
                        url: '/CancelOrder',
                        moduleID: 6014
                    },

                    {
                        name: gets('$包材管理'),
                        tag: 'PackInfo',
                        url: '/PackInfo',
                        moduleID: 28
                    },
                    {
                        name: gets('$订单迁入'),
                        tag: 'OrderToMoveIn',
                        url: '/OrderToMoveIn',
                        moduleID: 6011
                    },

                    {
                        name: gets('$已迁入订单打印'),
                        tag: 'OrderToMoveInPrint',
                        url: '/OrderToMoveInPrint',
                        moduleID: 6011
                    },

                ]
            },
            {
                name: gets('$推广'),
                twoNavs: [{
                        name: gets('$推广文本维护'),
                        tag: 'AddPopularize',
                        url: '/AddPopularize',
                        moduleID: 12001
                    },
                    {
                        name: gets('$佣金提现汇率'),
                        tag: 'GeneralizeRate',
                        url: '/GeneralizeRate',
                        moduleID: 12002
                    },

                    {
                        name: gets('$佣金记录'),
                        tag: 'Commission',
                        url: '/Commission',
                        moduleID: 12003
                    },

                    {
                        name: gets('$提现审核'),
                        tag: 'Generalize',
                        url: '/Generalize',
                        moduleID: 12004
                    },


                ]
            },

        ],
        openNavs: []
    },
    mutations: {
        increment(state) {}
    },
    actions: {
        setIsShow(context, obj) {}
    },
    getters: {}
}

const routerNavs ={
    state: {
        name: 'Top',
        navs: [
            {
                name: gets('$账户管理'),
                twoNavs: [


                    {
                      name: gets('$个人信息'),
                      tag: 'PersonalInformation',
                      url: '/PersonalInformation',
                      moduleID: -1000
                  },

                ]
            },
            {
                name: gets('$订单'),
                twoNavs: [

                    {
                        name: gets('$订单列表'),
                        tag: 'Order',
                        url: '/Order',
                    },
                    {
                        name: gets('$账目明细'),
                        tag: 'MyPaidDetail',
                        url: '/MyPaidDetail',
                        moduleID: 6006
                    },
                    {
                        name: gets('$店铺列表'),
                        tag: 'ShopCustomer',
                        url: '/ShopCustomer',
                    },
                    {
                        name: gets('$Earnings'),
                        tag: 'Earnings',
                        url: '/Earnings',
                        moduleID: 6006
                    },
                    {
                        name: gets('$我的工单'),
                        tag: 'MyQuestion',
                        url: '/MyQuestion',
                        moduleID: 6016
                    },
                    {
                        name: gets('$商城'),
                        tag: 'MyShoppingMall',
                        url: '/MyShoppingMall',
                        moduleID: 14001
                    },
                ]
            },
           




        ],
        openNavs: []
    },
    mutations: {
        increment(state) {}
    },
    actions: {
        setIsShow(context, obj) {}
    },
    getters: {}
}

const CustomerNavs = {
    state: {
        name: 'Top',
        navs: [        
            {
                name: gets('$平台店铺'),
                twoNavs: [
                    {
                        name: gets('$开通仓库'),
                        tag: 'MyCustomerWhouse',
                        url: '/MyCustomerWhouse',
                        moduleID: 14
                    },{
                        name: gets('$店铺列表'),
                        tag: 'ShopCustomer',
                        url: '/ShopCustomer',
                    },
                    {
                        name: gets('$店铺产品列表'),
                        tag: 'MyShopProduct',
                        url: '/MyShopProduct/0',
                        moduleID: 6021
                    },
                    {
                        name: gets('$仓库产品列表'),
                        tag: 'MyProduct',
                        url: '/MyProduct',
                        moduleID: 6002
                    },
                    // {
                    //     name: gets('$店铺分析'),
                    //     tag: 'StoreAnalysis',
                    //     url: '/StoreAnalysis',
                    //     moduleID: 6024
                    // },
                ]
            },
          
            {
                name: gets('$订单'),
                twoNavs: [
                    // {
                    //     name: gets('$新建订单'),
                    //     tag: 'AddOrder',
                    //     url: '/AddOrder/0/0',
                    //     moduleID: 5
                    // },
                    {
                        name: gets('$订单列表'),
                        tag: 'Order',
                        url: '/Order',
                    },

                    // {
                    //     name: gets('$店铺列表'),
                    //     tag: 'ShopCustomer',
                    //     url: '/ShopCustomer',
                    // },
                    // {
                    //   name: gets('$发件人管理'),
                    //   tag: 'SendAddress',
                    //   url: '/SendAddress',
                    // },
                    // {
                    //   name: gets('$收件人管理'),
                    //   tag: 'ReceiverAddress',
                    //   url: '/ReceiverAddress',
                    // },

                    {
                        name: gets('$运费查询'),
                        tag: 'FreightInquiries',
                        url: '/FreightInquiries',
                        moduleID: 6016
                    },


                    // {
                    //     name: gets('$我的工单'),
                    //     tag: 'MyQuestion',
                    //     url: '/MyQuestion',
                    //     moduleID: 6016
                    // },

                    // {
                    //     name: gets('$操作指引'),
                    //     tag: 'HelpGuide',
                    //     url: '/HelpGuide',
                    //     moduleID: 6016
                    // },
                ]
            },


            {
                name: gets('$采购管理'),
                twoNavs: [
                    // {
                    //     name: gets('$新增询价'),
                    //     tag: 'MyAddPurchaseRequest',
                    //     url: '/MyAddPurchaseRequest/0',
                    //     moduleID: 13001
                    // },

                    {
                        name: gets('$询价列表'),
                        tag: 'MyPurchaseRequest',
                        url: '/MyPurchaseRequest',
                        moduleID: 13001
                    },


                    // {
                    //     name: gets('$新增采购单'),
                    //     tag: 'MyAddASN_Purchases',
                    //     url: '/MyAddASN_Purchases/0',
                    //     moduleID: 6005
                    // },

                    {
                        name: gets('$采购列表'),
                        tag: 'MyASN_Purchases',
                        url: '/MyASN_Purchases',
                        moduleID: 6005
                    },

                ]
            },


            {
                name: gets('$仓库'),
                twoNavs: [
                   
                    // {
                    //   name: gets('$产品类型'),
                    //   tag: 'MyProductType',
                    //   url: '/MyProductType',
                    //   moduleID: 6001
                    // },
                    
                    // {
                    //     name: gets('$店铺产品列表'),
                    //     tag: 'MyShopProduct',
                    //     url: '/MyShopProduct/0',
                    //     moduleID: 6021
                    // },

                    {
                        name: gets('$产品映射'),
                        tag: 'MySkuMapping',
                        url: '/MySkuMapping',
                        moduleID: 6003
                    },
                    // {
                    //   name: gets('$供应商'),
                    //   tag: 'MySupplier',
                    //   url: '/MySupplier',
                    //   moduleID: 6004
                    // },



                    {
                        name: gets('$我的库存'),
                        tag: 'MyInventoryCustomer',
                        url: '/MyInventoryCustomer',
                        moduleID: 6006
                    },

                ]
            },


            {
                name: gets('$财务管理'),
                twoNavs: [{
                        name: gets('$账目明细'),
                        tag: 'MyPaidDetail',
                        url: '/MyPaidDetail',
                        moduleID: 6006
                    },
                    {
                        name: gets('$账单明细'),
                        tag: 'MyInvoice',
                        url: '/MyInvoice',
                        moduleID: 6006
                    },


                ]
            },



            // {
            //     name: gets('$账户管理'),
            //     twoNavs: [


            //     //     {
            //     //       name: gets('$个人信息'),
            //     //       tag: 'PersonalInformation',
            //     //       url: '/PersonalInformation',
            //     //       moduleID: -1000
            //     //   },
            //     //   {
            //     //     name: gets('$邮件配置'),
            //     //     tag: 'PersonalEmail',
            //     //     url: '/PersonalEmail',
            //     //     moduleID: 6006
            //     //   },
            //     //   {
            //     //     name: gets('$邮件模板设置'),
            //     //     tag: 'MyEmailMessage',
            //     //     url: '/MyEmailMessage',
            //     //     moduleID: 35
            //     //     },
            //         // {
            //         //     name: gets('$密码修改'),
            //         //     tag: 'UpdatePassword',
            //         //     url: '/UpdatePassword',
            //         //     moduleID: 6006
            //         // },


            //     ]
            // },

            {
                name: gets('$推广管理'),
                twoNavs: [{
                        name: gets('$Earnings'),
                        tag: 'Earnings',
                        url: '/Earnings',
                        moduleID: 6006
                    },
                    {
                        name: gets('$Payout Requests'),
                        tag: 'PayoutRequests',
                        url: '/PayoutRequests',
                        moduleID: 6006
                    },

                    {
                        name: gets('$Payout List'),
                        tag: 'MyGeneralize',
                        url: '/MyGeneralize',
                        moduleID: 6006
                    },
                    {
                        name: gets('$FAQ'),
                        tag: 'FAQ',
                        url: '/FAQ',
                        moduleID: 6006
                    },
                    {
                        name: gets('$Referrals'),
                        tag: 'Referrals',
                        url: '/Referrals',
                        moduleID: 6006
                    },



                    // {
                    //   name: gets('$我的佣金'),
                    //   tag: 'MyPopularize',
                    //   url: '/MyPopularize',
                    //   moduleID: 6006
                    // },


                ]
            },
            // {
            //     name: gets('$商城'),
            //     twoNavs: [
            //         {
            //             name: gets('$商城'),
            //             tag: 'MyShoppingMall',
            //             url: '/MyShoppingMall',
            //             moduleID: 14001
            //         },


            //     ]
            // },
            
            // {
            //     name: gets('$售后理赔'),
            //     twoNavs: [{
            //             name: gets('$售后理赔'),
            //             tag: 'AfterSale',
            //             url: '/AfterSale',
            //             moduleID: 6023
            //         },
                                    

            //     ]
            // },




        ],
        openNavs: []
    },
    mutations: {
        increment(state) {}
    },
    actions: {
        setIsShow(context, obj) {}
    },
    getters: {}
}

const loadButton = {
    state: []
}


export var Selects = {

    UserStatus: {
        state: [{
                Text: gets("$正常"),
                Value: 1
            },
            {
                Text: gets("$禁用"),
                Value: 2
            },
            {
                Text: gets("$删除"),
                Value: -1
            },
        ]
    },
    FinancialWarningStatus:{
        state:[
            {
                Text:gets("是"),
                Value:true
            },
            {
                Text:gets("否"),
                Value:false
            },
        ]
    },
    
    PaymentsType: {
        state: [{
                Text: gets("$预付"),
                Value: 0
            },
            {
                Text: gets("$月结"),
                Value: 1
            },
           
        ]
    },

    OrderSCNType: {
        state: [{
                Text: gets("$正常"),
                Value: 0
            },
            {
                Text: gets("$拆单"),
                Value: 1
            },
            {
                Text: gets("$合单"),
                Value: 2
            },
            {
                Text: gets("$复制"),
                Value: 3
            },
        ]
    },

    SourceList:{
        state: [ {
            Text: gets("other"),
            Value: 0
        },
        {
            Text: gets("Sean agent"),
            Value: 1
        },
        {
            Text: gets("Cathy agent"),
            Value: 2
        },
        {
            Text: gets("google ad discovery"),
            Value: 3
        },
        {
            Text: gets("Clement agent"),
            Value: 4
        },        
    ]
    },


    UserLevels: {
        state: [ {
            Text: gets("under 50, batch orders 100-300"),
            Value: 1
        },
        {
            Text: gets("50-300, batch orders 300-500"),
            Value: 2
        },
        {
            Text: gets("300_500, batch orders 500_1000"),
            Value: 3
        },
        {
            Text: gets("300_800, batch orders >1000, Customers have the financial strength to do OEM/ODM"),
            Value: 4
        },
            // {
            //     Text: gets("Less than 30 orders / day"),
            //     Value: 0
            // },
            // {
            //     Text: gets("30 to 100 orders / day"),
            //     Value: 1
            // },
            // {
            //     Text: gets("100 to 500 orders / day"),
            //     Value: 2
            // },
            // {
            //     Text: gets("500 to 1000 orders / day"),
            //     Value: 3
            // },
            // {
            //     Text: gets("1000+ orders / day"),
            //     Value: 4
            // },
        ]
    },

    ServeLevels: {
        state: [{
                Text: gets("Dropshipping / Branding"),
                Value: 1
            },
            {
                Text: gets("Amazon FBA"),
                Value: 2
            },
            {
                Text:gets("Affiliation"),
                Value:3
            },
            {
                Text:gets("B2B Business"),
                Value:4
            },
        ]
    },
    contactType: {
        state: [{
                Text: gets("WeChat"),
                Value: 1
            },
            {
                Text: gets("Skype"),
                Value: 2
            },
            {
                Text: gets("WhatsApp"),
                Value: 3
            },
        ]
    },
    PushEmail: {
        state: [{
                Text: gets("是"),
                Value: true
            },
            {
                Text: gets("否"),
                Value: false
            },
        ]
    },
    UserGender: {
        state: [{
                Text: gets("$男"),
                Value: '1'
            },
            {
                Text: gets("$女"),
                Value: '2'
            },
        ]
    },
    UserType: {
        state: [{
                Text: gets("$系统"),
                Value: 0
            },
            {
                Text: gets("$客户用户"),
                Value: 1
            },
        ]
    },
    IsAndNot: {
        state: [{
                Text: gets("$是"),
                Value: true
            },
            {
                Text: gets("$否"),
                Value: false
            },
        ]
    },
    ReceiveBoxTime: {
        state: [
            {
                Text: gets("$采购单10天以上未完成工单"),
                Value: 4
            },
            {
                Text: gets("$采购单3天内未完成工单"),
                Value: 1
            },
            {
                Text: gets("$采购单3天以上未完成工单"),
                Value: 2
            },
            {
                Text: gets("$采购单7天以上未完成工单"),
                Value: 3
            },
           
        ]
    },
    ReceiveBoxColor: {
        state: [{
                Text: gets("$橘色"),
                Value: 0
            },
            {
                Text: gets("$红色"),
                Value: 1
            },
            {
                Text: gets("$蓝色"),
                Value: 2
            },
            {
                Text: gets("$绿色"),
                Value: 3
            },
            {
                Text: gets("$白色"),
                Value: 4
            },
           
        ]
    },

    YesAndNo: {
        state: [{
                Text: gets("$是"),
                Value: 1
            },
            {
                Text: gets("$否"),
                Value: 0
            },
        ]
    },
    IsAndNotInt: {
        state: [{
                Text: gets("$是"),
                Value: 1
            },
            {
                Text: gets("$否"),
                Value: 0
            },
        ]
    },
    ChannelInfoStatus: {
        state: [{
                Text: gets("$正常"),
                Value: 1
            },
            {
                Text: gets("$停用"),
                Value: -1
            },
            {
                Text: gets("$上级渠道停用"),
                Value: -2
            },
        ]
    },
    LabelType: {
        state: [{
                Text: "A",
                Value: "A"
            },
            {
                Text: "B",
                Value: "B"
            },
            {
                Text: "C",
                Value: "C"
            },
            {
                Text: "D",
                Value: "D"
            },
            {
                Text: "E",
                Value: "E"
            },
            {
                Text: "F",
                Value: "F"
            },
            {
                Text: "G",
                Value: "G"
            },
            {
                Text: "H",
                Value: "H"
            },
            {
                Text: "I",
                Value: "I"
            },
            {
                Text: "J",
                Value: "J"
            },
            {
                Text: "K",
                Value: "K"
            },
            {
                Text: "L",
                Value: "L"
            },
            {
                Text: "M",
                Value: "M"
            },
            {
                Text: "N",
                Value: "N"
            },
            {
                Text: "O",
                Value: "O"
            },
            {
                Text: "P",
                Value: "P"
            },
            {
                Text: "Q",
                Value: "Q"
            },
            {
                Text: "R",
                Value: "R"
            },
            {
                Text: "S",
                Value: "S"
            },
            {
                Text: "T",
                Value: "T"
            },
            {
                Text: "U",
                Value: "U"
            },
            {
                Text: "V",
                Value: "V"
            },
            {
                Text: "W",
                Value: "W"
            },
            {
                Text: "X",
                Value: "X"
            },
            {
                Text: "Y",
                Value: "Y"
            },
            {
                Text: "Z",
                Value: "Z"
            },

        ]
    },
    ChannelTypeStatus: {
        state: [{
                Text: gets("$正常"),
                Value: 1
            },
            {
                Text: gets("$禁用"),
                Value: 2
            },
            {
                Text: gets("$删除"),
                Value: -1
            },
        ]
    },
    ChannelAreaPriceType: {
        state: [{
                Text: "H",
                Value: "H"
            },
            {
                Text: "P",
                Value: "P"
            },
            {
                Text: "W",
                Value: "W"
            },
            {
                Text: "Y",
                Value: "Y"
            }
        ]
    },
    NextCompanyStatus: {
        state: [{
                Text: gets("$正常"),
                Value: 1
            },
            {
                Text: gets("$禁用"),
                Value: 2
            },
            {
                Text: gets("$删除"),
                Value: -1
            },
        ]
    },
    SubChannelInfoStatus: {
        state: [{
                Text: gets("$正常"),
                Value: 1
            },
            {
                Text: gets("$禁用"),
                Value: 2
            },
            {
                Text: gets("$删除"),
                Value: -1
            },
        ]
    },
    WarehouseStatus: {
        state: [{
                Text: gets("$正常"),
                Value: 1
            },
            {
                Text: gets("$禁用"),
                Value: 2
            },
            {
                Text: gets("$删除"),
                Value: -1
            },
        ]
    },
    WareHousesZoneStatus: {
        state: [{
                Text: gets("$正常"),
                Value: 1
            },
            {
                Text: gets("$禁用"),
                Value: 2
            },
            {
                Text: gets("$删除"),
                Value: -1
            },
        ]
    },
    WareHousesShelfStatus: {
        state: [{
                Text: gets("$正常"),
                Value: 1
            },
            {
                Text: gets("$禁用"),
                Value: 2
            },
            {
                Text: gets("$删除"),
                Value: -1
            },
        ]
    },
    WareHousesLocationStatus: {
        state: [{
                Text: gets("$正常"),
                Value: 1
            },
            {
                Text: gets("$禁用"),
                Value: 2
            },
            {
                Text: gets("$删除"),
                Value: -1
            },
        ]
    },
    WareHousesPathStatus: {
        state: [{
                Text: gets("$正常"),
                Value: 1
            },
            {
                Text: gets("$禁用"),
                Value: 2
            },
            {
                Text: gets("$删除"),
                Value: -1
            },
        ]
    },
    CustomerWhouseStatus: {
        state: [{
                Text: gets("$正常"),
                Value: 1
            },
            {
                Text: gets("$禁用"),
                Value: 2
            },
        ]
    },
    WareHousesShelfType: {
        state: [{
                Text: gets("$单面"),
                Value: 0
            },
            {
                Text: gets("$双面"),
                Value: 1
            }
        ]
    },
    OrderOpentorFeeType: {
        state: [{
                Text: gets("$按箱收费"),
                Value: 0
            },
            {
                Text: gets("$按sku收费"),
                Value: 1
            }
        ]
    },
    ShelfFaceType: {
        state: [{
                Text: gets("$A面"),
                Value: 1
            },
            {
                Text: gets("$B面"),
                Value: 2
            }
        ]
    },
    ChannelItemSetupItemType: {
        state: [{
                Text: gets("$字符串"),
                Value: 0
            },
            {
                Text: gets("$整数"),
                Value: 1
            },
            {
                Text: gets("$数值型"),
                Value: 2
            },
            {
                Text: gets("$日期"),
                Value: 3
            }
        ]
    },
    ParcelSigningStatus: {
        state: [
            {
                Text: gets("$未签收"),
                Value: 1
            },
            {
                Text: gets("$已签收"),
                Value: 2
            },
            {
                Text: gets("$已上架"),
                Value: 3
            },
            {
                Text: gets("$异常"),
                Value: 4
            }
        ]
    },
    ChannelInfoZoneType: {
        state: [{
                Text: gets("$国家"),
                Value: 1
            },
            {
                Text: gets("$邮编"),
                Value: 2
            },
            {
                Text: gets("$其他"),
                Value: 3
            }
        ]
    },
    ChannelInfoFeeType: {
        state: [{
                Text: gets("$体积总和比重"),
                Value: 1
            },
            {
                Text: gets("$逐个包裹比重"),
                Value: 2
            },
            {
                Text: gets("$逐个包裹比重扣费"),
                Value: 3
            },
            {
                Text: gets("$逐个体积重累加"),
                Value: 4
            }
        ]
    },


    PublicDataType: {
        state: [{
                Text: gets("$重量单位"),
                Value: 5
            },
            {
                Text: gets("$货币单位"),
                Value: 6
            }
        ]
    },
    OrganizationType: {
        state: [{
                Text: gets("$代理"),
                Value: 1
            },
            {
                Text: gets("$电商"),
                Value: 2
            }
        ]
    },
    OrganizationStatus: {
        state: [{
                Text: gets("$正常"),
                Value: 1
            },
            {
                Text: gets("$禁用"),
                Value: 2
            },
            {
                Text: gets("$删除"),
                Value: -1
            },
            {
                Text: gets("$待审核"),
                Value: 3
            },
        ]
    },

    OrganizationSettlementMethod: {
        state: [{
                Text: gets("$预付"),
                Value: 0
            },
            {
                Text: gets("$月结"),
                Value: 1
            },
        ]
    },
    purchaseAcountStatus: {
        state: [{
                Text: gets("$停用"),
                Value: 0
            },
            {
                Text: gets("$启用"),
                Value: 1
            },
        ]
    },
    PublicDataPublicType: {
        state: [{
                Text: gets("$重量单位"),
                Value: 5
            },
            {
                Text: gets("$货币单位"),
                Value: 6
            },
        ]
    },
    PublicDataStatus: {
        state: [{
                Text: gets("$正常"),
                Value: 1
            },
            {
                Text: gets("$禁用"),
                Value: 2
            },
            {
                Text: gets("$删除"),
                Value: -1
            },
        ]
    },
    SendAddressStatus: {
        state: [{
                Text: gets("$正常"),
                Value: 1
            },
            {
                Text: gets("$禁用"),
                Value: 2
            },
            {
                Text: gets("$删除"),
                Value: -1
            },
        ]
    },
    WareHousesShelfShelfType: {
        state: [{
                Text: gets("$单面"),
                Value: 0
            },
            {
                Text: gets("$双面"),
                Value: 1
            },
        ]
    },

    Calculate: {
        state: [{
                Text: "+",
                Value: "+"
            },
            {
                Text: "-",
                Value: "-"
            },
            {
                Text: "*",
                Value: "*"
            },
        ]
    },

    ChannelItemSetupItemType: {
        state: [{
                Text: gets("$整数"),
                Value: 1
            },
            {
                Text: gets("$数值型(带小数)"),
                Value: 2
            },
            {
                Text: gets("$日期"),
                Value: 3
            },
        ]
    },

    UserAutherized: {
        state: [{
                Text: gets("$待认证"),
                Value: 1
            },
            {
                Text: gets("$已认证"),
                Value: 2
            },
            {
                Text: gets("$认证不通过"),
                Value: 3
            },
        ]
    },


    AddServiceStatus: {
        state: [{
                Text: gets("$正常"),
                Value: 1
            },
            {
                Text: gets("$禁用"),
                Value: 2
            },
            {
                Text: gets("$删除"),
                Value: -1
            },
        ]
    },



    ProductTypeStatus: {
        state: [{
                Text: gets("$正常"),
                Value: 1
            },
            {
                Text: gets("$禁用"),
                Value: 2
            },
        ]
    },

    ProductStatus: {
        state: [{
                Text: gets("$正常"),
                Value: 1
            },
            {
                Text: gets("$禁用"),
                Value: 2
            },
        ]
    },


    SupplierStatus: {
        state: [{
                Text: gets("$正常"),
                Value: 1
            },
            {
                Text: gets("$禁用"),
                Value: 2
            },
        ]
    },

    SkuMappingStatus: {
        state: [{
                Text: gets("$正常"),
                Value: 1
            },
            {
                Text: gets("$禁用"),
                Value: 2
            },
        ]
    },

    ASN_PurchasesStatus: {
        state: [{
                Text: gets("$待入库"),
                Value: 0
            },
            {
                Text: gets("$部分入库"),
                Value: 1
            },
            {
                Text: gets("$已入库"),
                Value: 2
            },
            {
                Text: gets("$待采购"),
                Value: 3
            },
            {
                Text: gets("$已采购"),
                Value: 4
            },
            {
                Text: gets("$已发货"),
                Value: 5
            },
            {
                Text: gets("$四天未上架"),
                Value: 6
            },
            {
                Text: gets("$七天未上架"),
                Value: 7
            },
            {
                Text: gets("$强制完成"),
                Value: 8
            },
            {
                Text: gets("$标记异常"),
                Value: 9
            },
            {
                Text: gets("$已作废"),
                Value: 10
            },
        ]
    },
    ASN_PurchasesNewStatus:{

        state: [{
            Text: gets("$待采购"),
            Value: 0
        },
        {
            Text: gets("$已采购"),
            Value: 1
        },
        {
            Text: gets("$标记异常"),
            Value: 2
        },
        {
            Text: gets("$作废"),
            Value: 3
        },
        {
            Text: gets("$已完结"),
            Value: 4
        },       
    ]


    },
    Asn_PurExceptionType:{
        state: [
        {
            Text: gets("采购时间异常"),
            Value: "采购时间异常"
        },
        {
            Text: gets("发货时间异常"),
            Value: "发货时间异常"
        },
        {
            Text: gets("物流签收时间异常"),
            Value: "物流签收时间异常"
        },
        {
            Text: gets("仓库签收时间异常"),
            Value: "仓库签收时间异常"
        },
        {
            Text: gets("仓库上架时间异常"),
            Value: "仓库上架时间异常"
        },
        {
            Text: gets("上架标记异常"),
            Value: "上架标记异常"
        },       
        {
            Text: gets("7内未上架异常"),
            Value: "7内未上架异常"
        },
        
    ]
    },

    ASN_PurchasesNewStatus2:{

        state: [{
            Text: gets("$待采购"),
            Value: 0
        },
        {
            Text: gets("$已采购"),
            Value: 1
        },
        {
            Text: gets("$作废"),
            Value: 3
        },
        {
            Text: gets("$已完结"),
            Value: 4
        },       
    ]
    },

    ASN_PurchasesDeliveryType: {
        state: [{
                Text: gets("$申通快递"),
                Value: 0
            },
            {
                Text: gets("$圆通速递"),
                Value: 1
            },
            {
                Text: gets("$中通快递"),
                Value: 2
            },
            {
                Text: gets("$百世汇通"),
                Value: 3
            },
            {
                Text: gets("$韵达快递"),
                Value: 4
            },
            {
                Text: gets("$顺丰快递"),
                Value: 5
            },
            {
                Text: gets("$德邦快递"),
                Value: 6
            },
            {
                Text: gets("$货拉拉"),
                Value: 7
            },
            {
                Text: gets("$物流"),
                Value: 8
            },
        ]
    },


    ASN_ReceivesStatus: {
        state: [{
                Text: gets("$已收货"),
                Value: 0
            },
            {
                Text: gets("$已上架"),
                Value: 1
            },
            //{ Text: gets("$已作废"), Value: 10 },
        ]
    },



    OrderStatus: {
        state: [{
                Text: gets("$草稿"),
                Value: 0
            },
            {
                Text: gets("$确认"),
                Value: 1
            },
            {
                Text: gets("$处理中"),
                Value: 7
            },
            {
                Text: gets("$待付款"),
                Value: 2
            },
            {
                Text: gets("$待发货"),
                Value: 3
            },
            {
                Text: gets("$已发货"),
                Value: 4
            },
            {
                Text: gets("$退件"),
                Value: 5
            },
        ]
    },

    BankInfoStatus: {
        state: [{
                Text: gets("$正常"),
                Value: 1
            },
            {
                Text: gets("$禁用"),
                Value: 2
            },
        ]
    },
    //发货情况
    CustomerDeliveryStatus: {
        state: [{
                Text: gets("2019-12"),
                Value: 1
            },
            {
                Text: gets("2019-11"),
                Value: 2
            },
        ]
    },

    AccountInComeAccountType: {
        state: [{
                Text: gets("$入账"),
                Value: 0
            },
            {
                Text: gets("$出账"),
                Value: 1
            },
        ]
    },
    InvoiceInvoiceType: {
        state: [{
                Text: gets("$订单"),
                Value: 0
            },
            {
                Text: gets("$费用补扣"),
                Value: 1
            },
            {
                Text: gets("$采购单"),
                Value: 2
            },
        ]
    },
    InvoiceStatus: {
        state: [{
                Text: gets("$待审核"),
                Value: 0
            },
            {
                Text: gets("$已审核"),
                Value: 1
            },
            {
                Text: gets("$待收款"),
                Value: 2
            },
            {
                Text: gets("$已完结"),
                Value: 3
            },
            {
                Text: gets("$已作废"),
                Value: 10
            },
            {
                Text: gets("$坏账"),
                Value: 11
            },
        ]
    },
    InvoiceStatus2: {
        state: [{
                Text: gets("$待审核"),
                Value: 0
            },
            {
                Text: gets("$待确认"),
                Value: 1
            },
            {
                Text: gets("$待收款"),
                Value: 2
            },

            {
                Text: gets("$已完结"),
                Value: 3
            },
            {
                Text: gets("$已作废"),
                Value: 10
            },
            {
                Text: gets("$坏账"),
                Value: 11
            },
        ]
    },

    OrderDetailCount: {
        state: [{
                Text: gets("$1个产品"),
                Value: 1
            },
            {
                Text: gets("$多产品单SKU"),
                Value: 2
            },
            {
                Text: gets("$多产品"),
                Value: 3
            },
        ]
    },

    financial_status: {
        state: [{
                Text: "paid(已付款)",
                Value: "paid"
            },
            {
                Text: "unpaid(未付款)",
                Value: "unpaid"
            },
            {
                Text: "partially_refunded(部分退款)",
                Value:  "partially_refunded"
            },
            {
                Text: "refunded(已退款)",
                Value: "refunded"
            },
            {
                Text: "any(所有)",
                Value: "any"
            },
        ]
    },
    OrderDetailCountPickUp: {
        state: [{
                Text: gets("$1个产品"),
                Value: 1
            },
            {
                Text: gets("$多产品单SKU"),
                Value: 2
            },
            {
                Text: gets("$多产品"),
                Value: 3
            },
        ]
    },

    FieldJson: {
        state: [{
                Text: gets("$输入框"),
                Value: "String"
            },
            {
                Text: gets("$下拉框"),
                Value: "Select"
            },
            {
                Text: gets("$时间选择"),
                Value: "Datetime"
            },
        ]
    },

    PriorityLevel: {
        state: [{
                Text: gets("$一般"),
                Value: "0"
            },
            {
                Text: gets("$紧急"),
                Value: "1"
            },
            {
                Text: gets("$严重"),
                Value: "2"
            },
        ]
    },


    QuestionSortNO: {
        state: [{
                Text: gets("$按优先等级时间正序"),
                Value: "1"
            },
            {
                Text: gets("$按优先等级时间倒序"),
                Value: "2"
            },
            {
                Text: gets("$按时间正序"),
                Value: "3"
            },
            {
                Text: gets("$按时间倒序"),
                Value: "4"
            },
        ]
    },

    QuestionStatus: {
        state: [{
                Text: gets("$待处理"),
                Value: "0"
            },
            {
                Text: gets("$处理中"),
                Value: "1"
            },
            {
                Text: gets("$已完结"),
                Value: "2"
            },
        ]
    },
    RegistrationDiscountDiscountType: {
        state: [{
                Text: gets("$公共折扣"),
                Value: 0
            },
            {
                Text: gets("$指定客户"),
                Value: 1
            },
        ]
    },

    RegistrationDiscountCalculateType: {
        state: [{
                Text: gets("+"),
                Value: "+"
            },
            {
                Text: gets("-"),
                Value: "-"
            },
            {
                Text: gets("*"),
                Value: "*"
            },
            {
                Text: gets("$固定费用"),
                Value: "G"
            },
        ]
    },

    InventoryInAndOutInAndOut: {
        state: [{
                Text: gets("入库"),
                Value: 0
            },
            {
                Text: gets("出库"),
                Value: 1
            },
        ]
    },

    InventoryInAndOutInAndOutType: {
        state: [{
                Text: gets("调整上架"),
                Value: 0
            },
            {
                Text: gets("调整下架"),
                Value: 1
            },
            {
                Text: gets("拣货出库"),
                Value: 2
            },
            //{ Text: gets("盘点"), Value: 3 },
            {
                Text: gets("转移"),
                Value: 4
            },
        ]
    },

    InventoryInAndOutInAndOutType2: {
        state: [{
                Text: gets("调整上架"),
                Value: 0
            },
            {
                Text: gets("调整下架"),
                Value: 1
            },
        ]
    },


    OrderSort: {
        state: [{
                Text: gets("$创建时间倒序"),
                Value: 0
            },
            {
                Text: gets("$创建时间正序"),
                Value: 1
            },
            {
                Text: gets("$订单号倒序"),
                Value: 2
            },
            {
                Text: gets("$订单号正序"),
                Value: 3
            },
            {
                Text: gets("$跟踪号倒序"),
                Value: 4
            },
            {
                Text: gets("$跟踪号正序"),
                Value: 5
            },
            {
                Text: gets("$参考号倒序"),
                Value: 6
            },
            {
                Text: gets("$参考号正序"),
                Value: 7
            },
            {
              Text: gets("$平台时间倒序"),
              Value: 8  
          },
          {
              Text: gets("$平台时间正序"),
              Value: 9
          },
        ]
    },
 InvoiceSort: {
   state: [{
       Text: gets("$创建时间倒序"),
       Value: 0
     },
     {
       Text: gets("$创建时间正序"),
       Value: 1
     },


     {
       Text: gets("$参考号倒序"),
       Value: 6
     },
     {
       Text: gets("$参考号正序"),
       Value: 7
     },
   ]
 },


    IsAutoGetOrderFlag: {
        state: [{
                Text: gets("$Yes"),
                Value: "1"
            },
            {
                Text: gets("$No"),
                Value: "0"
            },
        ]

    },


    DeveliverType: {
        state: [{
                Text: gets("$Delivered"),
                Value: "Delivered"
            },
            {
                Text: gets("$In Transit"),
                Value: "In Transit"
            },
            {
                Text: gets("$Returned to sender"),
                Value: "Returned to sender"
            },
            {
                Text: gets("$Exception"),
                Value: "Exception"
            },
            {
                Text: gets("$Acceptance scan"),
                Value: "Acceptance scan"
            },
            {
                Text: gets("$Arrival scan"),
                Value: "Arrival scan"
            },
            {
                Text: gets("$Departure Scan"),
                Value: "Departure Scan"
            },
            {
                Text: gets("$Out For Delivery"),
                Value: "Out For Delivery"
            },
        ]
    },
    Sys_NewStatus: {
        state: [{
                Text: gets("$待发布"),
                Value: 0
            },
            {
                Text: gets("$已发布"),
                Value: 1
            },
            {
                Text: gets("$已作废"),
                Value: 10
            },
        ]
    },

    Sys_NewSeeType: {
        state: [{
                Text: gets("$全部查看"),
                Value: 0
            },
            {
                Text: gets("$仅客户查看"),
                Value: 1
            },
            {
                Text: gets("$仅系统查看"),
                Value: 2
            },
        ]
    },

    ShopCustomerAllGetType: {
        state: [{
                Text: gets("$获取所有SKU订单"),
                Value: true
            },
            {
                Text: gets("$获取映射SKU订单"),
                Value: false
            },
        ]
    },

    ShopProductStatus: {
        state: [{
                Text: gets("$正常"),
                Value: 1
            },
            {
                Text: gets("$禁用"),
                Value: 2
            },
        ]
    },

    AccountInComeFeeType: {
        state: [{
                Text: gets("$运费充值"),
                Value: 0
            },
            {
                Text: gets("$采购充值"),
                Value: 1
            },
        ]
    },

    GeneralizeGType: {
        state: [{
                Text: gets("$充值"),
                Value: 1
            },
            {
                Text: gets("$提现到银行"),
                 Value: 2
             },
             {
               Text: gets("$提现到paypal"),
               Value: 3
             },
              {
                Text: gets("$提现到payoneer"),
                Value: 4
              },
        ]
    },


    GeneralizeStatus: {
        state: [
            {
                Text: gets("$申请中"),
                Value: 1
            },
            {
                Text: gets("$已审核"),
                Value: 2
            },
            {
                Text: gets("$已完结"),
                Value: 3
            },
            {
                Text: gets("$驳回"),
                Value: 10
            },
        ]
    },


    PurchaseRequestStatus: {
        state: [{
                Text: gets("$待提交"),
                Value: 0
            },
            {
                Text: gets("$处理中"),
                Value: 1
            },
            {
                Text: gets("$已完结"),
                Value: 2
            },
            {
                Text: gets("$已作废"),
                Value: 10
            },
        ]
    },
    AddOrderStatus: {
        state: [{
                Text: gets("$获取所有订单"),
                Value: 0
            },
            {
                Text: gets("$获取退款订单"),
                Value: 1
            },
            {
                Text: gets("$获取取消订单"),
                Value: 2
            },
        ]
    },

    EmailMessageStatus: {
        state: [{
                Text: gets("$启用"),
                Value: 1
            },
            {
                Text: gets("$停用"),
                Value:0
            },

        ]
    },


    InventoryCheckCheckStatus: {
        state: [{
                Text: gets("$处理中"),
                Value: 1
            },
            {
                Text: gets("$待审核"),
                Value:2
            },

            {
                Text: gets("$已审核"),
                Value:3
            },


            {
                Text: gets("$已驳回"),
                Value:4
            },
            {
                Text: gets("$作废"),
                Value:5
            },
        ]
    },
    WhetherOutOfStock: {
        state: [
            {
                Text: gets("$否"),
                Value: 0
            },
            {
                Text: gets("$暂时缺货"),
                Value: 1
            },
            {
                Text: gets("$永久缺货"),
                Value:2
            },
        ]
    },
    ProductStatusEdit: {
        state: [{
                Text: gets("$已上传"),
                Value: 1
            },
            {
                Text: gets("$等待报价"),
                Value:0
            },

        ]
    },
    ASN_PurchasesIsPayStatus: {
        state: [{
                Text: gets("$未付款"),
                Value: 0
            },
            {
                Text: gets("$已付款"),
                Value:1
            },
            {
                Text: gets("$部分付款"),
                Value:2
            },

        ]
    },
    PaymentStatus: {
        state: [{
                Text: gets("$线上支付"),
                Value: 0
            },
            {
                Text: gets("$线下支付"),
                Value:1
            },
          

        ]
    },
    ExportOrderStatus: {
        state: [{
                Text: gets("$确认"),
                Value: 1
            },
            {
                Text: gets("$处理中"),
                Value:7
            },
            {
                Text: gets("$未付款待发货"),
                Value: 2
            },
            {
                Text: gets("$已付款待发货"),
                Value:3
            },
            {
                Text: gets("$已发货"),
                Value: 4
            },
            {
                Text: gets("$缺货"),
                Value:6
            },
            {
                Text: gets("$问题件"),
                Value: 5
            },
            {
                Text: gets("$已作废"),
                Value:10
            },
            {
                Text: gets("$草稿"),
                Value: 0
            },
            {
                Text: gets("$预报中"),
                Value:9
            },
        ]
    },


}



export var UserRights = {
    state: {
        Rights: null,
        UserContext: null,
    },
    getters: {
        UserRights() {
            if (!UserRights.state.Rights) {
                userRequest.GetUserRights(function(d) {
                    UserRights.state.Rights = d.Rights;
                    UserRights.state.UserContext = d.UserContext;
                    if (window.UserRightsLoadEnd) {
                        window.UserRightsLoadEnd()
                    }
                }, {})
            }
            return UserRights.state.Rights;
        }
    }
}


import Vuex from 'vuex'
Vue.use(Vuex)

var modules = {
    Frame: Frame,
    Navs: Navs,
    name:name,
    CustomerNavs: CustomerNavs,
    routerNavs: routerNavs,
    loadButton: loadButton,
    UserRights: UserRights
}

for (var key in Selects) {
    modules[key] = Selects[key];
}

const store = new Vuex.Store({
    modules: modules
})

export default store



// WEBPACK FOOTER //
// ./src/model/store.js